var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlide2Home(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M26.664,53.336A18.859,18.859,0,1,1,40,58.86a18.86,18.86,0,0,1-13.336-5.524M40,0A40,40,0,1,0,68.284,11.716,39.876,39.876,0,0,0,40,0Z",
    transform: "translate(0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M22.23,76.29l-12.6,24.947A40.005,40.005,0,0,0,86.23,82.56c-9.638,18.151-30.544,28.919-48.186,19.663a18.75,18.75,0,0,1-2.264-1.31c-3.447-2.189-5.105-4.079-5.493-5.707A18.88,18.88,0,0,1,36.68,69.062a6.989,6.989,0,0,0-1.025-.074c-6.085,0-13.425,7.3-13.425,7.3",
    transform: "translate(-9.635 -68.988)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M11.715,25.717a40,40,0,0,0,39.9,66.568C19.732,92.043,7.635,59.7,26.664,40.666a18.862,18.862,0,0,1,20.21-4.23l2.108-3.344L42.345,28.03,16.908,21.336a40.292,40.292,0,0,0-5.192,4.381",
    transform: "translate(0 -21.336)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M11.719,11.716a40,40,0,0,0-9.7,40.834c-4.37-17.637,16.9-36.3,41.45-31.089a21.067,21.067,0,0,1,4.159,1.284A10.572,10.572,0,0,0,59.4,20.608l.1-.1A10.506,10.506,0,0,0,56.36,3.485a40.043,40.043,0,0,0-44.641,8.231",
    transform: "translate(-0.005)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dp-crypto-logo",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 94.641,
    height: 94.641,
    transform: "translate(-15.328 82.321) rotate(-82.1)",
    fill: "#f6f5fa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(3.312 23.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 77.346,
    height: 60.192,
    transform: "translate(0 -0.001)",
    fill: "#a2a2a2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(0 7.334)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(0)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 118.381,
    height: 93.87,
    transform: "translate(-31.198 89.268) rotate(-81.63)",
    fill: "#727272"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 116.2,
    height: 117.115,
    transform: "matrix(0.675, -0.737, 0.737, 0.675, -51.356, 29.576)",
    fill: "#991bfa"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide2Home);
export default __webpack_public_path__ + "static/media/slide2_home.31673bcaf4181d46859304e645e5e2c3.svg";
export { ForwardRef as ReactComponent };